// Reusable Sign-in / Account pill in the top-right.
import React from "react";
import { LogOut } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

const GoogleG = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true">
    <path fill="#EA4335" d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"/>
    <path fill="#34A853" d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"/>
    <path fill="#FBBC05" d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9 9 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"/>
    <path fill="#4285F4" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.96 13.04C2.45 15.98 5.48 18 9 18z"/>
  </svg>
);

export default function SignInButton({ compact = false }) {
  const { user, signIn, signOut, loading } = useAuth();

  if (loading) {
    return (
      <button className="meye-chip" disabled data-testid="auth-loading">
        <div className="meye-spinner" />
      </button>
    );
  }

  if (user) {
    return (
      <button
        onClick={signOut}
        className="meye-chip"
        title="Sign out"
        data-testid="user-chip"
        style={{ background: "rgba(255,255,255,0.06)", borderColor: "rgba(255,255,255,0.16)" }}
      >
        {user.picture ? (
          <img
            src={user.picture}
            alt=""
            referrerPolicy="no-referrer"
            style={{ width: 22, height: 22, borderRadius: 999, objectFit: "cover" }}
          />
        ) : (
          <div style={{ width: 22, height: 22, borderRadius: 999, background: "linear-gradient(135deg,#7F4BFF,#22E2FF)" }} />
        )}
        <span className="text-sm" style={{ color: "rgba(255,255,255,0.9)" }}>
          {(user.name || user.email || "").split(" ")[0]}
        </span>
        <LogOut size={14} style={{ opacity: 0.55 }} />
      </button>
    );
  }

  return (
    <button
      onClick={signIn}
      className="inline-flex items-center gap-2 rounded-full bg-white text-black font-medium px-4 py-2 text-sm transition hover:bg-white/90"
      data-testid="signin-google"
      style={{ minHeight: 40 }}
    >
      <GoogleG />
      <span>{compact ? "Sign in" : "Sign in with Google"}</span>
    </button>
  );
}
